module.exports = __webpack_public_path__ + "static/media/pl-background.174d3db0.png";